module.exports = __webpack_public_path__ + "media/images/custom_page/bae173/cards-d9de87b0571fc93df6ebc259e0322a4c.svg";